/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensagemModalAliases {
  FIELD_MENSAGEM = 'field-mensagem',
  FORM_MENSAGEM = 'form-mensagem',
  LAYOUT_0 = 'layout-0',
  PANEL_0 = 'panel-0',
  TEXT_0 = 'text-0',
}
export { MensagemModalAliases };
